/*
 * Calc languages of code from markdown file.
 * Languages are passed at this function like "language-{lang}".
 * We can have multiple languages (e.g: "language-{lang}; language-{lang2}")
 */
export const getParams = (name = ``) => {
  const [lang, params = ``] = name.split(`:`);
  return [lang.split(`language-`).pop().split(`{`).shift()].concat(
    params.split(`&`).reduce((merged, param) => {
      const [key, value] = param.split(`=`);
      merged[key] = value;
      return merged as any;
    }, {})
  );
};
